import { render, staticRenderFns } from "./FourwavesBadge.vue?vue&type=template&id=006ba24f"
import script from "./FourwavesBadge.vue?vue&type=script&lang=ts"
export * from "./FourwavesBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports